<div class="component-type-conditions">
  <div>
    @if (parent.length) {
      <h3 class="row" (click)="expanded=!expanded;" style="cursor:pointer;margin-bottom:0;">
        @if (!expanded) {
          <mat-icon>arrow_right</mat-icon>
        }
        @if (expanded) {
          <mat-icon>arrow_drop_down</mat-icon>
        }
        Edit conditions for component type {{component_type.attributes.name}}
      </h3>
    }
    @if (expanded || !parent.length) {
      <div class="row column-selector">
        <div class="draggable-list-container">
          <h2>Selected Columns</h2>
          <mat-form-field [floatLabel]="'never'" class="property-search-input">
            <input [(ngModel)]='selectedColumnFilterValue' matInput placeholder="Search" autocomplete="off">
          </mat-form-field>
          <div #selectedList="cdkDropList"
            id="selectedList"
            (cdkDropListDropped)="drop($event)"
            [cdkDropListConnectedTo]="[availableList]"
            [cdkDropListData]="selectedColumns"
            cdkDropList
            class="draggable-list">
            @for (option of selectedColumns | filterByValue: columnFilter.bind(this) : selectedColumnFilterValue; track $index) {
              <div
                cdkDrag [id]="option"
                class="draggable-list-item"
                style="display:flex; justify-content: space-between;">
                <div style="flex: 1.5">{{option| upperfirst}}</div>
                <div style="flex: 1;">
                  @if (!col_info_dict[option]) {
                    <input [(ngModel)]="col_value_dict[option]"
                      matInput (ngModelChange)="emitEvent()" name="tile_title" style="width: auto"/>
                  }
                  @if (col_info_dict[option] && col_info_dict[option].type == 'component_type') {
                    <mat-checkbox
                      [(ngModel)]="col_value_dict['[component_type@' + col_info_dict[option].id +']'].is_set"
                      (ngModelChange)="emitEvent()"
                      name="show_header"> Is Set
                    </mat-checkbox>
                  }
                  @if (col_info_dict[option] && col_info_dict[option].type == 'constant_property') {
                    <input
                      matInput
                      [(ngModel)]="col_value_dict['[constant_property@' + col_info_dict[option].id +']']"
                      (ngModelChange)="emitEvent()"
                      [name]="option"/>
                  }
                </div>
                <div style="display: flex; flex: 0.5; justify-content: right;">
                  @if (col_info_dict[option] && col_info_dict[option].type=='component_type') {
                    <span>(CT)</span>
                  }
                  @if (col_info_dict[option] && col_info_dict[option].type=='constant_property') {
                    <span>(CP)</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div class="draggable-list-container">
          <h2>Available Column</h2>
          <mat-form-field [floatLabel]="'never'" class="property-search-input">
            <input [(ngModel)]='availableColumnFilterValue' matInput placeholder="Search" autocomplete="off">
          </mat-form-field>
          <div #availableList="cdkDropList"
            id="availableList"
            (cdkDropListDropped)="drop($event)"
            [cdkDropListConnectedTo]="[selectedList]"
            [cdkDropListData]="available_column_options"
            cdkDropList
            class="draggable-list">
            @for (option of available_column_options | filterByValue: columnFilter.bind(this) : availableColumnFilterValue; track $index) {
              <div
                cdkDrag class="draggable-list-item" [id]="option"
                style="display:flex; justify-content: space-between;">
                <div style="flex: 1.5;">
                  {{option| upperfirst}}
                </div>
                <div style="flex: 1">
                  @if (!col_info_dict[option]) {
                    <input [(ngModel)]="col_value_dict[option]"
                      matInput
                      [name]="option" style="width: auto"/>
                  }
                  @if (col_info_dict[option] && col_info_dict[option].type == 'component_type') {
                    <mat-checkbox
                      [(ngModel)]="col_value_dict['[component_type@' + col_info_dict[option].id +']'].is_set"
                      [name]="option"> Is Set
                    </mat-checkbox>
                  }
                  @if (col_info_dict[option] && col_info_dict[option].type == 'constant_property') {
                    <input
                      matInput
                      [(ngModel)]="col_value_dict['[constant_property@' + col_info_dict[option].id +']']"
                      [name]="option"/>
                  }
                </div>
                <div style="display: flex; flex: 0.5; justify-content: right;">
                  @if (col_info_dict[option]) {
                    <span>
                      @if (col_info_dict[option].type=='component_type') {
                        <span>(CT)</span>
                      }
                      @if (col_info_dict[option].type=='constant_property') {
                        <span>(CP)</span>
                      }
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
